import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getCookieConsent, setCookieConsent } from '../analytics';

const OPEN_EVENT = 'c2n-open-cookie-settings';

// Reopens the banner so a visitor can change their choice (footer "Cookie settings").
export const openCookieSettings = () => window.dispatchEvent(new Event(OPEN_EVENT));

// Bottom banner asking before any non-essential cookie is set. Until the visitor chooses, Google
// Analytics stays off; the choice is remembered on this device.
const CookieConsent: React.FC = () => {
  const [open, setOpen] = useState(() => getCookieConsent() === null);

  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener(OPEN_EVENT, show);
    return () => window.removeEventListener(OPEN_EVENT, show);
  }, []);

  if (!open) return null;

  const choose = (choice: 'accepted' | 'denied') => {
    setCookieConsent(choice);
    setOpen(false);
  };
  const current = getCookieConsent();

  return (
    <section className="cookie-banner" role="region" aria-live="polite" aria-label="Cookie consent">
      <div>
        <b>We value your privacy</b>
        <p>
          We use essential storage to keep you signed in. With your permission we also use analytics cookies
          (Google Analytics) to understand how Cheers2Night is used and improve it. You can change your choice at any
          time from <i>Cookie settings</i> in the footer.{' '}
          <Link className="gold" to="/privacy#cookies">Cookie policy</Link>
        </p>
        {current && <p className="cookie-current">Current choice: {current === 'accepted' ? 'all cookies accepted' : 'cookies denied'}.</p>}
      </div>
      <div className="cookie-actions">
        <button type="button" className="btn btn-dark" onClick={() => choose('denied')}>Deny Cookies</button>
        <button type="button" className="btn btn-gold" onClick={() => choose('accepted')}>Accept All Cookies</button>
      </div>
    </section>
  );
};

export default CookieConsent;
